import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { PosTerminalDto } from "../../../../dtos/catalogs/PosTerminal/PosTerminalDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFLookupAccount } from "../../../Shared/NewForms/NFLookupAccount";
import { NFLookupRetailSettings } from "../../../Shared/NewForms/NFLookupRetailSettings";
import PosTerminalDetailSkeleton from "./PosTerminalDetailSkeleton";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import PosTerminalDetailMain from "./PosTerminalDetailMain";

interface IProps {
  model: PosTerminalDto | null;
  modelUpdatedEvent: (newModel: PosTerminalDto) => void;
}

interface PosTerminalModel {
  id: string;
  name: string;
  uniqueCode?: string;
  createdDate?: Date;
  accountId?: string;
  retailSettingId?: string;
  posTerminalNumber?: string;
}

export const PosTerminalDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const [selectType, setSelectType] = useState(0);

  const handleTypeChange = (value: any) => {
    setSelectType(value);
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<PosTerminalModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (model) {
      setValue("id", model.id);
      setValue("name", model.name);
      setValue("uniqueCode", model.uniqueCode);
      setValue("createdDate", model.createdDate);
      setValue("accountId", model.accountId);
      setValue("retailSettingId", model.retailSettingId);
      setValue("posTerminalNumber", model.posTerminalNumber);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: PosTerminalModel) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    // return;
    if (action === "save") {
      const newModel: PosTerminalModel = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
      await saveHandler(newModel);
    }
    console.log("form submit finish");
  };

  if (!model) {
    return (
      <>
        <PosTerminalDetailSkeleton />
      </>
    );
  }

  const handleTabChange = (index: number) => {
    setTabIndex(index);
  };
  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
        </NFTabs>
        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <PosTerminalDetailMain/>
        </NFTabContainer>
      </FormProvider>
    </>
  );
};
